import { TextField } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import axios from "axios";
import { useState } from "react";
import { useAppContext } from "../../../context/AuthContext";
import Endpoints from "../../../utils/Endpoints";
import { handleErrorMessage } from "../../../utils/Utils";

interface ResetPasswordType {
  open: boolean;
  handleClose?: any;
}

export default function ResetPassword(props: ResetPasswordType) {
  const { open, handleClose } = props;
  const { showMessage } = useAppContext();
  const [email, setEmail] = useState<string>("");

  const restPasswordAction = () => {
    axios
      .post(`${Endpoints.RESET_PASSWORD}`, { email: email })
      .then((result: any) => {
        handleClose();
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Reset password</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            If you have forgotten your password, please fill in your email address in the field below and press send. An
            email with a new password will be send to you.
            <TextField
              variant="outlined"
              margin="normal"
              id="email"
              name="email"
              label="Email"
              value={email}
              onChange={(e: any) => {
                setEmail(e.target.value);
              }}
              // onBlur={handleBlur}
              // error={touched.passwordRepeat && Boolean(errors.passwordRepeat)}
              // helperText={touched.passwordRepeat && errors.passwordRepeat}
              fullWidth
              required
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" variant="outlined">
            Cancel
          </Button>
          <Button onClick={restPasswordAction} color="primary" variant="contained" autoFocus>
            Send
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
